import { render } from "./Talks.vue?vue&type=template&id=4d9422ac"
import script from "./Talks.vue?vue&type=script&lang=js"
export * from "./Talks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__